<template>
  <div>
    <mobialis-form-with-validation @onValidate="continueForm">
      <div :class="{ 'row justify-content-between': showBlocks }">
        <div :class="{ 'col-sm-7': showBlocks }">
          <Hero
            :title="$t('message.insurance.hero.homeAddress')"
            :text="$t('message.insurance.hero.homeAddressText')"
          ></Hero>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.credit.streetAddress')"
            v-model="streetAddress"
            vid="streetaddress"
            data-cy="streetAddress"
          ></mobialis-text-input-with-validation>
          <div class="row">
            <mobialis-text-input-with-validation
              class="col-5 col-sm-12"
              :label="$t('message.credit.unit#')"
              v-model="unitNumber"
              vid="unitNumber"
              data-cy="unitNumber"
            ></mobialis-text-input-with-validation>
          </div>
          <mobialis-text-input-with-validation
            rules="required"
            :label="$t('message.common.city')"
            v-model="city"
            vid="city"
            data-cy="city"
          ></mobialis-text-input-with-validation>
          <mobialis-selection-input-with-validation
            rules="required"
            :label="$t('message.common.state')"
            v-model="state"
            vid="province"
            :placeHolder="$t('message.common.chooseState')"
            :options="states"
            data-cy="state"
          ></mobialis-selection-input-with-validation>
          <mobialis-text-input-with-validation
            rules="required|length:5"
            :label="$t('message.common.zipCode')"
            v-model="zipCode"
            vid="zipCode"
            data-cy="zipCode"
            mask-type="zipCode"
          ></mobialis-text-input-with-validation>
        </div>
        <div v-if="showBlocks" class="col-sm-4 d-none d-sm-block">
          <DisclaimerCard
            class="card border-0 shadow mb-2"
            :iconSrc="require('@/assets/eye.svg')"
            :title="$t('message.insurance.disclaimer.thirdCardTitle')"
            :text="$t('message.insurance.disclaimer.thirdCardText')"
            :text-left-space="false"
          ></DisclaimerCard>
        </div>
      </div>
      <mobialis-button data-cy="submitForm2" type="submit" class="mt-4 mb-1">
        {{ $t('message.common.continue') }}
      </mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import Hero from '@/components/insurance/hero/Hero.vue';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import { stateMixin } from '@/mixins';
import log from '@/services/log';

export default {
  name: 'HomeAddress',
  components: { Hero, DisclaimerCard },
  mixins: [stateMixin],
  computed: {
    showBlocks() {
      return this.$route.meta.showBlocks;
    },
    streetAddress: {
      get() {
        return this.$store.state.user.streetAddress;
      },
      set(value) {
        this.$store.commit('user/SET_STREET_ADDRESS', value);
      },
    },
    unitNumber: {
      get() {
        return this.$store.state.user.unit;
      },
      set(value) {
        this.$store.commit('user/SET_UNIT', value);
      },
    },
    city: {
      get() {
        return this.$store.state.user.city;
      },
      set(value) {
        this.$store.commit('user/SET_CITY', value);
      },
    },
    state: {
      get() {
        return this.$store.state.user.state;
      },
      set(value) {
        this.$store.commit('user/SET_STATE_CODE', this.getStateCode(value));
        this.$store.commit('user/SET_STATE', value);
      },
    },
    zipCode: {
      get() {
        return this.$store.state.user.zipCode;
      },
      set(value) {
        this.$store.commit('user/SET_ZIP_CODE', value);
      },
    },
  },
  methods: {
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }

      try {
        this.$store.commit('SET_LOADING', true);
        await this.$store.dispatch('lead/updateLead');
        this.$router.push({ name: `additional-questions-${this.baseRoute}` });
      } catch (err) {
        log('Error in Insurance Home address - Update Lead', err);
        this.$router.push({ name: `insurance-error-${this.baseRoute}` });
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style scoped></style>
